import { Heading as o } from "../../node_modules/@tiptap/extension-heading/dist/index.mjs";
import { HEADING_STYLES as l } from "../../constants/default-styles.mjs";
import { convertStyleObjectToCss as s } from "../../utils/style-helpers.mjs";
import { mergeAttributes as n } from "../../node_modules/@tiptap/core/dist/index.mjs";
const v = o.extend({
  renderHTML({ node: e, HTMLAttributes: r }) {
    const t = [2, 3, 4].includes(e.attrs.level) ? e.attrs.level : 2;
    return [
      `h${t}`,
      n(
        {
          dir: "auto",
          style: s(l[t] ?? {})
        },
        r
      ),
      0
    ];
  }
});
export {
  v as HeadingExtension
};
